

const Waves = () => {
  return (
    <>
      <svg
        width="100%"
        height="100%"
        id="svg"
        viewBox="0 0 1440 400"
        xmlns="http://www.w3.org/2000/svg"
        className="transition duration-300 ease-in-out delay-150">
        <path
          d="M 0,400 C 0,400 0,133 0,133 C 79.34102564102565,124.04102564102564 158.6820512820513,115.08205128205128 246,124 C 333.3179487179487,132.91794871794872 428.61282051282046,159.71282051282054 518,157 C 607.3871794871795,154.28717948717946 690.8666666666667,122.06666666666666 762,103 C 833.1333333333333,83.93333333333334 891.9205128205126,78.02051282051282 967,84 C 1042.0794871794874,89.97948717948718 1133.4512820512823,107.85128205128206 1215,118 C 1296.5487179487177,128.14871794871794 1368.2743589743588,130.57435897435897 1440,133 C 1440,133 1440,400 1440,400 Z"
          stroke="none"
          // stroke-width={"0"}
          fill="#4394e388"
          className="transition-all duration-300 ease-in-out delay-150 path-0"
          transform="rotate(-180 720 200)"
        ></path>
        <path
          d="M 0,400 C 0,400 0,266 0,266 C 68.73846153846151,244.15128205128207 137.47692307692301,222.3025641025641 223,218 C 308.523076923077,213.6974358974359 410.8307692307693,226.94102564102565 491,228 C 571.1692307692307,229.05897435897435 629.1999999999999,217.9333333333333 713,218 C 796.8000000000001,218.0666666666667 906.3692307692309,229.325641025641 980,241 C 1053.6307692307691,252.674358974359 1091.3230769230768,264.7641025641026 1162,269 C 1232.6769230769232,273.2358974358974 1336.3384615384616,269.6179487179487 1440,266 C 1440,266 1440,400 1440,400 Z"
          stroke="none"
          // stroke-width={"0"}
          fill="#4394e3ff"
          className="transition-all duration-300 ease-in-out delay-150 path-1"
          transform="rotate(-180 720 200)"
        ></path>
      </svg>
    </>
  );
};

export default Waves;
